import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const WindowsMono: BleskIcon = forwardRef(function User(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.671 20.472L4.671 18.139C3.707 17.978 3 17.144 3 16.166V7.834C3 6.856 3.707 6.022 4.671 5.861L18.671 3.528C19.89 3.325 21 4.265 21 5.5V18.5C21 19.735 19.89 20.675 18.671 20.472Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 4.89V19.11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.86H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
